import { createFileRoute } from '@tanstack/react-router'

import { ConfirmationPage } from '@/features/auth'

export const Route = createFileRoute('/_auth/confirmation')({
  component: ConfirmationPage
})
